module.exports = __webpack_public_path__ + "img/stripe-logo.34786d0b.png";